// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"793df25e","665":"271a7607"}[chunkId] + ".chunk.js";
};